
import React, { Component } from 'react';
import { controls } from '../controls';


const aadhaarScanner = {
  label: "Aadhaar Scanner",
  pageLabel: "Aadhaar Scanner",
  starting: true,
  url: "as",
  pageType: "history",
  form: [
    ...controls.qrCodeReader({ onScan: 'fillData', dataType: 'aadhaar', name: 'aadhaar_data', previewStyle: { height: 200, width: 200 }, onScanComplete: { action: 'closemodal', value: 'aadhaarScanner' } }),
  ]
};

export default aadhaarScanner;

